// extracted by mini-css-extract-plugin
export default {"buttonGroup":"style_buttonGroup__9EVys","backBtn":"style_backBtn__MmPVL","nextBtn":"style_nextBtn__8c5Sa","backIcon":"style_backIcon__gF4cL"};